import { MAXIMUN_INPUT_VALUE } from 'utils/consts';
import * as Yup from 'yup';

const validadeValue = (value) => {
  if (!value) return true;
  return value <= MAXIMUN_INPUT_VALUE;
};

const messageTest = 'O valor não pode ser maior que 100.000.000';

export const saleSchema = Yup.object({
  stakeholder: Yup.object().nullable().required('Campo Obrigatório'),
  price: Yup.number()
    .required('Campo Obrigatório')
    .test('max-value', messageTest, validadeValue)
    .test('zero-value', 'Insira o preço da venda.', (value) => value !== 0)
    .test('greater-than-zero', 'Preço de venda deve ser maior que 0.', (value) => value > 0)
    .typeError('O preço deve ser um valor válido'),
  discount: Yup.number(),
  unit_price: Yup.number()
    .required('Campo Obrigatório')
    .test('max-value', messageTest, validadeValue)
    .typeError('O preço unitário deve ser um valor válido'),
  quantity: Yup.number()
    .min(0, 'Precisa ser acima de 0')
    .required('Campo Obrigatório')
    .test('max-value', messageTest, validadeValue),
  description: Yup.string().max(
    100,
    'Máximo de caracteres ultrapassado (100 caracteres).',
  ),
  harvest: Yup.object({
    cycles: Yup.array().required('Campo Obrigatório').test('is-non-empty', 'Campo obrigatório', (array) => array && array.length > 0),
  }),
  // stakeholder: Yup.string().required('Campo Obrigatório'),
});
